// SEQ-199: when a refresh fails (or Retry is loading), the grid keeps showing the
// last table that loaded instead of wiping it. What is kept is the last good
// model INPUT with the request it was built for, never display text, so the
// table is rebuilt at render and Safe Mode masking is always current. It is
// used only while the request still matches: a changed range, filter set or
// months-without-costs choice must never leave old figures under new labels.

export interface LastGoodGrid<T> {
  /** The request (range, filters, switch) the input was built for. */
  key: string;
  input: T;
}

/**
 * The input to rebuild a stale table from, or null. Never used while a current
 * model exists, never across a request change, and only while a refetch is
 * failed or in flight.
 */
export function staleGridInput<T>(
  lastGood: LastGoodGrid<T> | null,
  requestKey: string,
  hasCurrent: boolean,
  fetching: boolean,
): T | null {
  if (hasCurrent || lastGood === null || lastGood.key !== requestKey || !fetching) return null;
  return lastGood.input;
}
